import { observable } from 'mobx';
import { Resource } from './Resource';
import { ResourceCollection } from './ResourceCollection';

type ResourceItem = Resource | ResourceCollection;

export class ResourceStore {
  static _sharedStore?: ResourceStore;

  id = 0;

  @observable resources: { [key: string]: ResourceItem } = {};

  static shared(): ResourceStore {
    if (typeof ResourceStore._sharedStore === 'undefined') {
      const store = new ResourceStore();
      ResourceStore._sharedStore = store;
    }
    return ResourceStore._sharedStore;
  }

  setResource(name: string, item: ResourceItem): ResourceItem {
    if (typeof this.resources[name] !== 'undefined') {
      throw new Error(`resource ${name} already exists`);
    }
    this.resources[name] = item;
    return this.resources[name];
  }

  destroyResource(name: string) {
    delete this.resources[name];
  }

  getResource(name: string): ResourceItem | null {
    return this.resources[name] || null;
  }

  numberOfLoadingResources(): number {
    let count = 0;
    for (let key of Object.keys(this.resources)) {
      const resource = this.resources[key];
      if (resource.loading) {
        count++;
      }
    }
    return count;
  }
}



// WEBPACK FOOTER //
// ./src/store/ResourceStore.ts